module.exports = __webpack_public_path__ + "static/offices-content-image-2@2x-f4b89de312fa29b68423ed4d3d5cbb01.jpg";